import React from "react";
 import StringCounter from "./TableCounter"
const App = () => {
  return <StringCounter/>;
};

export default App;
